import { ENDPOINTS, NEW_ENDPOINTS } from '@constants'
import { IUserLoginCreds, IUserRegister } from '@typings'
import { AxiosResponse } from 'axios'
import { IAuthUser } from 'src/typings/auth.typings'
import { BaseApi } from './_base.api'

export class AuthApi extends BaseApi {
  getToken = async ({ email, password }: IUserLoginCreds) => {
    return await this.api
      .post(ENDPOINTS.AUTH.TOKEN, {
        email,
        password,
      })
      .then(
        (
          res: AxiosResponse<{
            access_token: string
            refresh_token: string
          }>
        ) => res.data
      )
  }

  login = async ({ email, password }: IUserLoginCreds) =>
    await this.api
      .post<AxiosResponse<IAuthUser>>(NEW_ENDPOINTS.AUTH.LOGIN, {
        email,
        password,
      })
      .then(res => res.data.data)

  register = async (data: IUserRegister) =>
    await this.api.post(ENDPOINTS.AUTH.REGISTER, { ...data }).then(res => res.data)

  refreshToken = async (refresh_token: string) => {
    return await this.api.post(ENDPOINTS.AUTH.REFRESH_TOKEN, { refresh_token }).then(res => res.data)
  }

  logout = async (refresh_token: string) =>
    await this.api.post(ENDPOINTS.AUTH.LOGOUT, { refresh_token }).then(res => res)

  forgotPassword = async (email: string) =>
    await this.api.post(NEW_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email }).then(res => res.data)

  resetPassword = async (data: { email: string; password: string; password_confirmation: string; token: string }) =>
    await this.api.post(NEW_ENDPOINTS.AUTH.RESET_PASSWORD, data).then(res => res.data)

  verifyEmail = async (id: string, hash: string) =>
    await this.api.get(NEW_ENDPOINTS.AUTH.VERIFY_EMAIL(id, hash)).then(res => res.data)
}
